export class CarUserTokenOperationsEntity {
  userId;
  siteId;
  userTypeId;
  carUserTokens;

  constructor(userId, siteId, userTypeId, carUserTokens) {
    this.userId = userId;
    this.siteId = siteId;
    this.userTypeId = userTypeId;
    this.carUserTokens = carUserTokens;
  }
}
